import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import HeaderNew from '../../components/Panel/HeaderNew';
import LeftDrawerNew from '../../components/Panel/LeftDrawerNew';
/* import withWidth from 'material-ui/utils/withWidth'; */
import withWidth from 'material-ui/utils/withWidth';
import ThemeDefault from '../../theme-default';
import LoginPageNew from './LoginPageNew';
import urlBase from '../../url-base';

const availWidth = window.screen.availWidth;

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: availWidth < 1400 ? false : true
    };
  }

  componentDidMount() {
    document.getElementById("container_page").style.paddingLeft = 0;
    document.getElementById("container_page").style.margin = 0;
    document.getElementById("container_page").style.fontFamily = "Roboto,sans-serif";
    document.getElementById("container_page").style.maxWidth = '100%';
    document.getElementsByTagName('body')[0].style.backgroundColor = '#ddd';
  }

  handleChangeRequestNavDrawer() {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen
    });
  }

  render() {
    let { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = availWidth < 1400 ? 0 : 290;

    const styles = {
      header: {
        paddingLeft: 0
      },
      container: {
        margin: '80px 20px 20px 15px',
        paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0
      }
    };

    // Se não estiver logado chama página de login
    if (window.localStorage.getItem('dental_t') == null ||
        window.localStorage.getItem('dental_u') == null ||
        window.localStorage.getItem('dental_y') == null ||
        window.localStorage.getItem('dental_n') == null ||
        window.localStorage.getItem('dental_i') == null) {
      return (
        <LoginPageNew />
      );
    }
    // Se estiver logado exibe área do admin
    else {
      // Nome padrão
      let localUserName = "Dental Center";
      // Imagem padrão
      let localUserImage = urlBase.client + 'assets/images/panel/user.png';

      if (window.localStorage.getItem('dental_n') != "undefined" &&
          window.localStorage.getItem('dental_n').length > 0) {

        localUserName = window.localStorage.getItem('dental_n').trim();
        let localUserNameSplit = localUserName.split(' - ');

        if (localUserNameSplit.length == 2) {
          localUserName = localUserNameSplit[1].split(' ');
          localUserName = localUserName[0] + ' ' + localUserName[localUserName.length -1 ];
        }
        else {
          localUserName = localUserName.split(' ');
          if (localUserName.length > 1)
            localUserName = localUserName[0] + ' ' + localUserName[localUserName.length -1 ];
          else
            localUserName = localUserName[0];
        }
      }

      if (window.localStorage.getItem('dental_i') != "undefined" &&
          window.localStorage.getItem('dental_i').length > 0) {

        localUserImage = urlBase.loopBack + '/attachments/users/download/' + window.localStorage.getItem('dental_i');
      }

      return (
        <MuiThemeProvider muiTheme={ThemeDefault}>
          <div>
            <HeaderNew styles={styles.header}
                    handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer.bind(this)}
            />

              <div id="container_LeftDrawer">
                <LeftDrawerNew
                  navDrawerOpen={navDrawerOpen}
                  username={localUserName}
                  userimage={localUserImage}
                  //username="Nome Admin"
                  //userimage={urlBase.client + "assets/images/panel/hm.png"}
                  fnOpenClose={this.handleChangeRequestNavDrawer.bind(this)}
                />
              </div>

              <div style={styles.container}>
                {this.props.children}
              </div>
          </div>
        </MuiThemeProvider>
      );// End return logado
    }// End else logado

  }
}

App.propTypes = {
  children: PropTypes.element,
  /* width: PropTypes.number */
};

export default withWidth()(App);



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/Panel.js
 **/